import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import UnionIcon from 'components/Icons/UnionIcon';
import { colors } from 'theme';

const useStyles = makeStyles(theme => ({
  button: {
    padding: '1.5em 4em',
    border: '1px solid #E9EDEF',
    fontWeight: 600,
    textAlign: 'left',
    marginBottom: '2em',
    width: '60%',
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      '& *': {
        color: theme.palette.primary.main,
      },
    },
  },
  icon: {
    color: colors.grey500,
  },
}));

export interface ArrowButtonProps {
  aditionalClass?: string;
  disabled?: boolean;
  onClick: () => void;
}

const ArrowButton: React.FC<ArrowButtonProps> = ({ aditionalClass, disabled, onClick, children }) => {
  const classes = useStyles();

  return (
    <>
      <Button
        disabled={disabled}
        onClick={onClick}
        className={classNames(classes.button, aditionalClass)}
        variant="outlined"
      >
        {children}
        <UnionIcon className={classes.icon} />
      </Button>
    </>
  );
};

export default ArrowButton;
